export const getBootstrapColorName = (hex) => {
  const colors = {
    "#ddd": "muted",
    "#186BAF": "primary",
    "#18AF5C": "success",
    "#DFD734": "warning",
    "#DC741E": "danger"
  };
  return colors[hex];
};
